
import React from "react";
import OkrToolView from "../components/Okr";
import { SalesPageToolSet } from "./SalesPageToolSet";


const OkrToolContainer = (props) => {

    const [tool,setTool] = React.useState({});

    

    React.useEffect(()=>{
        if(props.match.params.id){
            let filteredTool =  SalesPageToolSet.find(value=>value.id === parseInt(props.match.params.id))
            setTool(filteredTool)
        }

    },[props.match.params.id])


    return (
        <>
            <OkrToolView tool = {tool} />
        </>
    );
};

export default OkrToolContainer;

